import { VirtualTable } from '@devexpress/dx-react-grid-material-ui'
import { Theme, useTheme } from '@mui/material'
import React from 'react'
import { Table as TableBase } from '@devexpress/dx-react-grid'
import { BooleanColumns } from './config'

type CombinedCellProps = TableBase.CellProps & TableBase.DataCellProps

const getFontColor = ({
  name,
  theme,
  value,
}: {
  name: string
  theme: Theme
  value: unknown
}) => {
  const isAvailable = name === 'isAvailable'
  const isClimate = name === 'isClimate'
  const isCovered = name === 'isCovered'
  const isStatusLabel = name === 'statusLabel'
  const isAvailableColor =
    isAvailable && Boolean(value) ? theme.palette.success.dark : 'inherit'
  const isClimateColor =
    isClimate && Boolean(value) ? theme.palette.primary.dark : 'inherit'
  const isCoveredColor =
    isCovered && Boolean(value) ? theme.palette.warning.dark : 'inherit'
  const statusColor =
    isStatusLabel && value === 'Available'
      ? theme.palette.success.dark
      : isStatusLabel && value === 'Pending cancellation'
        ? theme.palette.warning.dark
        : isStatusLabel && value === 'Move-out pending'
          ? theme.palette.info.dark
          : isStatusLabel && value === 'Cancellation needs review'
            ? theme.palette.error.dark
            : 'inherit'
  if (isAvailable) return isAvailableColor
  if (isClimate) return isClimateColor
  if (isCovered) return isCoveredColor
  if (isStatusLabel) return statusColor
  return 'inherit'
}
export const CustomTableCell: React.ComponentType<CombinedCellProps> = (
  props
) => {
  const { column, row, value } = props
  const theme = useTheme<Theme>()
  const isIndividualTable = row.isAvailable !== undefined
  const isBoolean = BooleanColumns.includes(column.name)
  const BooleanValue = isBoolean && value ? 'Yes' : 'No'
  const _color = getFontColor({
    name: column.name,
    theme,
    value: isBoolean ? Boolean(value) : value,
  })

  const showPointer = isIndividualTable && !row.isAvailable

  return (
    <VirtualTable.Cell
      {...props}
      column={column}
      row={row}
      value={value}
      sx={{
        color: _color,
        cursor: showPointer ? 'pointer' : 'inherit',
      }}
    >
      {isBoolean ? BooleanValue : value}
    </VirtualTable.Cell>
  )
}
